module.exports = __webpack_public_path__ + "static/media/js.9d61f88a.svg";